import React, { Component } from "react";
import "./filter-select.css";
import Select from "../../../../components/selects/select";

class FilterSelect extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      label,
      name,
      id,
      textSelected,
      itens,
      value,
      onChange,
      width,
      height,
      display,
      displayDiv,
      justifyContentDiv,
      alignItemsDiv,
      flexDirectionDiv,
      marginRight,
    } = this.props;
    const inputStyle = {
      width: width,
      height: height,
      display: display,
    };

    const divStyle = {
      display: displayDiv,
      justifyContent: justifyContentDiv,
      alignItems: alignItemsDiv,
      flexDirection: flexDirectionDiv,
      marginRight: marginRight,
    };

    return (
      <>
        {this.props.layout == "default" ? (
          <Select
            label={this.props.label}
            width="100%"
            name={this.props.name}
            aria={this.props.aria}
            itens={this.props.items}
            onChange={onChange}
            value={value == undefined ? "" : value}

          />
        ) : (
          <div className="divFiltroSelectContainer" style={divStyle}>
            <label className="filtroInputLabel" htmlFor="">
              {label}
            </label>
            <div className="filtroSelectOptionSlected">
              <select
                id={id? id : name}
                name={name}
                value={value == undefined ? "" : value}
                style={divStyle}
                onChange={onChange}
                className="filtroSelect"
                type="text"
                onKeyDown={this.props.onKeyDown}>
                <option value="" selected>
                  {textSelected}
                </option>
                {itens &&
                  itens.map((item, index) => (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  ))}
              </select>
              <div className="divSetaFiltroSelect">
                <span className="setaFiltroSelect"></span>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default FilterSelect;
